
module.exports = [
  'M6 2 L26 2 L26 30',
  'L16 24 L6 30 Z'
].join(' ')




//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/geomicons-open/src/paths/bookmark.js
// module id = 309
// module chunks = 6